/* Quantity buttons submit the existing native cart form. Shopify calculates every price. */
(() => {
  'use strict';
  const initialize = (root = document) => {
    root.querySelectorAll('[data-native-cart]:not([data-cart-ready])').forEach(form => {
      form.dataset.cartReady = 'true';
      const update = form.querySelector('[name="update"]');
      const checkout = form.querySelector('[name="checkout"]');
      const status = form.querySelector('[data-cart-feedback]');
      const buttons = Array.from(form.querySelectorAll('[data-cart-step]'));
      let pending = false;
      buttons.forEach(button => {
        const input = form.querySelector(`#${button.getAttribute('aria-controls')}`);
        if (!input || !form.requestSubmit) return;
        button.hidden = false;
        button.addEventListener('click', () => {
          if (pending) return;
          if (!input.value || !input.checkValidity()) { input.reportValidity(); return; }
          if (Number(button.dataset.cartStep) > 0) input.stepUp(); else input.stepDown();
          form.requestSubmit(update);
        });
      });
      form.querySelectorAll('[name="updates[]"]').forEach(input => input.addEventListener('input', () => {
        if (status) status.textContent = form.dataset.changed;
      }));
      form.addEventListener('submit', event => {
        if (pending) { event.preventDefault(); return; }
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        pending = true;
        form.setAttribute('aria-busy', 'true');
        buttons.forEach(button => { button.disabled = true; });
        form.querySelectorAll('[name="updates[]"]').forEach(input => { input.readOnly = true; });
        // Do not disable the submitter: Shopify must receive name="checkout" or name="update".
        if (event.submitter !== checkout) checkout.disabled = true;
        if (status) status.textContent = event.submitter === checkout ? form.dataset.checkout : form.dataset.updating;
      });
      window.addEventListener('pageshow', () => {
        pending = false;
        form.removeAttribute('aria-busy');
        buttons.forEach(button => { button.disabled = false; });
        checkout.disabled = false;
        form.querySelectorAll('[name="updates[]"]').forEach(input => { input.readOnly = false; });
        if (status) status.textContent = '';
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

